// @owners { team: patients-team }
import {
  ActionSheetContext,
  ActionSheetV2,
  AltoIcon,
  Column,
  H2,
  Illustration,
  MdPadding,
  Row,
  SmSpacing,
  XlSpacing,
} from '@alto/design-system';
import React, { useContext, useEffect } from 'react';
import { push } from 'react-router-redux';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { useDispatchShared } from '~shared/store';
import gear from '~web/images/gear.gif';

export const VerifiedDetailsActionSheet = ({ nextUrl }: { nextUrl: string }) => {
  const dispatch = useDispatchShared();
  const { closeActionSheet } = useContext(ActionSheetContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(push(nextUrl));
      closeActionSheet();
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [closeActionSheet, nextUrl, dispatch]);

  return (
    <ActionSheetV2 analyticsName="onboarding_verified_details">
      <MdPadding>
        <Column
          gap="XL"
          center
          flexGrow={1}
          flexShrink={1}
        >
          <Row
            center
            gap="MD"
          >
            <AltoIcon
              name="checkmark"
              accessibilityLabel={IMG_ALT_TEXTS.greenCheckmark}
            />
            <SmSpacing />
            <H2 center>Success!</H2>
          </Row>
          <Illustration
            size="xl"
            source={gear}
            accessibilityLabel="Verification complete gear Illustration"
          />
          <H2 center>Let's set up your account in just a few steps...</H2>
        </Column>
        <XlSpacing />
      </MdPadding>
    </ActionSheetV2>
  );
};
